<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div class="ui segment">

        <form class="ui form">
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Condição</label>
              <span v-if="isObject(quotation.descPayment)">Antes: {{ quotation.descPayment.__old }}</span>
              <p v-if="isObject(quotation.descPayment)"></p>
              <span>{{ isObject(quotation.descPayment) ? quotation.descPayment.__new : quotation.descPayment }}</span>
            </div>
            <div class="twelve wide field">
              <label class="form-label">Endereço Cobrança</label>
              <span v-if="isObject(billingAddress)">Antes: {{ billingAddress.__old }}</span>
              <p v-if="isObject(billingAddress)"></p>
              <span>{{ isObject(billingAddress) ? billingAddress.__new : billingAddress }}</span>
            </div>
          </div>
        </form>

      </div>

    </div>

  </div>

</template>

<script>

  import CustomerService from "@/services/customer-service"

  export default {
    
    props: ["quotation"],    

    computed: {

      billingAddress() {
        return CustomerService.billingAddress(this.quotation.customer)        
      },
    },

    methods: {
      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    },
  }

</script>
